import Controls from "../../../../components/form/controls/Controls";
import { useEffect, useState } from "react";
import useForm, { Form } from "../../../../hooks/useForm";

import { useHistory, useParams } from "react-router-dom";
import GridSelectPermission from "../../../../components/GridSelectPermission/GridSelectPermission";
import useSelectPermission from "../../../../hooks/useSelectPermission";
import { validationRoleInput } from "../../../../utils";
import {
  createRole,
  getDetailRole,
  updateRole,
} from "../../../../apis/System/role.api";
import { path } from "../../../../constants/path";

const initialValue = {
  id: "",
  name: "",
  description: "",
  permissionIds: [],
};
const RoleAction = () => {
  let { id } = useParams();
  const history = useHistory();
  const { checked, setChecked } = useSelectPermission([]);
  const [createAnother, setCreateAnother] = useState(false);
  // validation input employee
  const validateRoleForm = (fieldValues = values) => {
    let temp = validationRoleInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, resetForm, errors, setErrors, handleInputChange } =
    useForm(initialValue, true, validateRoleForm);

  useEffect(() => {
    if (id) {
      getDetailRole(id, (result) => {
        setValues({
          ...values,
          name: result.name,
          description: result.description,
          id: result.id,
        });
        const permissionIds = result.permissions.map(
          (permissions) => permissions.id
        );
        setChecked([...checked, ...permissionIds]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateRoleForm()) {
      const data = { ...values, permissionIds: checked };
      if (id) {
        updateRole(id, data, (result) => {
          // callback nhận về lỗi form và thành công
          if (result.data?.status === 422) {
            setErrors((error) => ({ ...error, ...result.data.data }));
          } else {
            history.push(`${path.systemRole}`);
          }
        });
      } else {
        createRole(data, (result) => {
          // callback nhận về lỗi form và thành công
          if (result.data?.status === 422) {
            setErrors((error) => ({ ...error, ...result.data.data }));
          } else {
            if (createAnother) {
              resetForm();
              setChecked([]);
            } else {
              history.push(`${path.systemRole}`);
            }
          }
        });
      }
    }
  };
  return (
    <div>
      <div className="page-header">
        <h2>{id ? "Edit Role" : "Create Role"}</h2>
      </div>
      <Form onSubmit={onSubmit}>
        <Controls.Input
          name="name"
          value={values.name}
          label="Name"
          type="text"
          onChange={handleInputChange}
          error={errors.name}
        />
        <Controls.Input
          name="description"
          value={values.description}
          label="Description"
          type="text"
          onChange={handleInputChange}
          error={errors.description}
        />

        {GridSelectPermission({ checked, setChecked })}
        {!id ? (
          <Controls.Checkbox
            name="createAnother"
            label="Create another"
            value={createAnother}
            onChange={() => setCreateAnother(!createAnother)}
          />
        ) : null}
        <Controls.Button
          sx={{ width: "100%", marginTop: "10px" }}
          type="submit"
          text="Submit"
        />
      </Form>
    </div>
  );
};

export default RoleAction;
